<template>
  <v-container>
    <v-row class="pa-4 ma-0 contenedor align-content-center flex-wrap d-flex">
      <v-col align="center" justify="space-around" md="12" sm="12" class="pa-0 ma-0" >
        <h1>{{ $STR.tituloCentroAyuda }} {{ sProducto }}</h1>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 titulo-contenedor align-content-center flex-wrap d-flex" v-if="getLogin">
      <v-col align="center" justify="space-around" md="12" sm="12" class="pa-0 ma-0" >
        <v-btn color="primary" elevation="2" medium rounded x-large @click="onClickAgregarMaterial()">
          {{ $STR.btnAgregarMaterial }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 align-content-center flex-wrap d-flex">
      <v-col align="center" justify="space-around" lg="12" md="12" sm="12" class="pa-0 ma-0" > 
        <h2>{{ $STR.subtituloBienvenido }}</h2>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <v-data-iterator :items="aModulos" items-per-page.sync="100" hide-default-footer >
          <template v-slot:header>
            <v-row class="pa-4 ma-0">
              <v-col lg="12" md="12" sm="12" class="pa-4 ma-0">
                <v-text-field
                  v-model="sBusqueda"
                  :label="sTextoBusqueda"
                  append-icon="fa-search"
                  background-color="white"
                  flat
                  hide-details
                  outlined
                  rounded
                  clearable
                  dense
                  @click:append="onBuscarPregunta"
                  @keyup.enter="onBuscarPregunta"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="3" md="6" sm="12" class="pa-4 ma-0" v-for="(item, index) in aPreguntasFrecuentes" :key="index" >
                <v-card @click="onCLickPregunta(item)" elevation="6" class="mx-auto" outlined > 
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle style="color:#14A7C3"> {{ item.Pregunta }} - {{ item.Tecnologia }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar>
                      <v-icon class="pa-4 ma-0" color="#14A7C3" left>
                        mdi-chevron-right
                      </v-icon>
                    </v-list-item-avatar>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="!$route.params.idProducto">
              <v-row class="pa-4 ma-0 titulo-contenedor-primary">
                <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
                  <h2>{{ $STR.subtituloCentroAyudaModulo }}</h2>
                </v-col>
              </v-row>
            </v-row>
          </template>

          <template v-slot:default="props">
            <v-row v-if="!$route.params.idProducto">
              <v-col class="pa-4 ma-0" v-for="item in props.items" :key="item.name" cols="12" sm="12" md="6" lg="4" >
                <v-card align="center" justify="space-around" elevation="8" shaped>
                  <v-card-title class="d-flex justify-center subtitulo-producto" >{{ item.Modulo }}</v-card-title>
                  <v-card-actions class="d-flex justify-center">
                    <v-btn color="primary" rounded @click="onClickModulo(item)"> 
                      {{ $STR.btnVer }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axiosServices from "@/services/axiosServices.js";
import { mapGetters } from 'vuex';
// import { mixFunciones } from "@/mixins/funciones.js";

export default {
  // mixins: [mixFunciones],
  mounted() {
    // tomamos el producto de la url de ..../producto/:idProducto
    const { idProducto } = this.$route.params
    if(idProducto) sessionStorage.setItem('producto', idProducto)
    
    // tomamos la tecnología de la url de ?tecnologia=valor&key=valor...
    const { tecnologia } = this.$route.query
    if(tecnologia) sessionStorage.setItem('tecnologia', tecnologia)

    
    this.onLoadData();
  },
  data() {
    return {
      cargando: false,
      sIP: sessionStorage.ip,
      sProducto: "",
      aPreguntasFrecuentes: [],
      sTextoBusqueda: this.$STR.textCualPregunta,
      aModulos: [],
      sBusqueda: "",
    };
  },
  methods: {
    onLoadData() {
      this.cargando = true;
      axiosServices.getConfiguration(`/base_conocimientos/productos`, false, `app=${this.sApp}`)
        .then((aResponse) => {
          const aProductos = aResponse.aData;
          aProductos.forEach((item) => {
            if (item.idBC_Productos == this.$route.params.idProducto) {
              this.sProducto = item.Producto;
            }
          });
          this.cargando = false;
        });
      const tecnologia = sessionStorage.getItem('tecnologia') || 2;
      axiosServices.getConfiguration( `/base_conocimientos/preguntas_frecuentes`, false, `app=${this.sApp}&producto=${this.$route.params.idProducto}&tecnologia=${tecnologia}`)
        .then((aResponse) => {
          this.aPreguntasFrecuentes = aResponse.aData;
          this.cargando = false;
        });

      axiosServices.getConfiguration( `/base_conocimientos/modulos`, false, `app=${this.sApp}&producto=${this.$route.params.idProducto}&tecnologia=${this.$route.query.tecnologia}`)
        .then((aResponse) => {
          this.aModulos = aResponse.aData;
          this.cargando = false;
        })
    },
    onClickModulo(item) {
      sessionStorage.sModulo = item.Modulo;
      sessionStorage.modulo = item.idBC_Modulos;
      const sPATH = `/Inicio/centro-de-ayuda/dashboard/producto/${sessionStorage.producto}/modulo/${item.idBC_Modulos}`;
      this.$router.push({ path: sPATH });
    },
    onClickAgregarMaterial() {
      this.$router.replace({ name: "NuevaPregunta" });
    },
    onCLickPregunta(item) {
      sessionStorage.item = JSON.stringify(item);
      this.$router.push({ path: `/Inicio/centro-de-ayuda/dashboard/producto/${sessionStorage.producto}/modulo/${item.idBC_Modulos}/pregunta/${item.idBC_Preguntas}`});
    },
    onBuscarPregunta() {
      if(this.sBusqueda === '' || !this.sBusqueda) {
        this.$swal.fire({
          title: 'Información',
          icon: 'info',
          text: 'Asegurese de completar el campo de busqueda'
        })
        return;
      }
      this.$router.push({path: `/Inicio/centro-de-ayuda/pregunta/busqueda?q=${this.sBusqueda}`});
    },
  },
  computed: {
    ...mapGetters(['getLogin'])
  }
};
</script>
